import { Header } from "@/components/Header";
import { PremiumFooter } from "@/components/landing/PremiumFooter";
import { Shield } from "lucide-react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <section className="pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
              <Shield className="w-8 h-8 text-primary" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4 font-display">
              Politique de Confidentialité
            </h1>
            <p className="text-muted-foreground">Dernière mise à jour : 3 décembre 2024</p>
          </div>

          <div className="prose prose-invert max-w-none">
            <div className="bg-card border border-border rounded-2xl p-8 space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">1. Introduction</h2>
                <p className="text-muted-foreground">
                  Chez Floop, nous prenons la protection de vos données personnelles très au sérieux. 
                  Cette politique de confidentialité explique comment nous collectons, utilisons, stockons 
                  et protégeons vos informations lorsque vous utilisez notre service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">2. Données collectées</h2>
                <p className="text-muted-foreground mb-4">Nous collectons les types de données suivants :</p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li><strong>Données de compte :</strong> email, nom d'utilisateur, mot de passe (chiffré)</li>
                  <li><strong>Données d'utilisation :</strong> prompts, images générées, préférences</li>
                  <li><strong>Données de paiement :</strong> traitées par notre partenaire Stripe</li>
                  <li><strong>Données techniques :</strong> adresse IP, type de navigateur, logs de connexion</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">3. Utilisation des données</h2>
                <p className="text-muted-foreground mb-4">Vos données sont utilisées pour :</p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Fournir et améliorer nos services</li>
                  <li>Gérer votre compte et vos crédits</li>
                  <li>Vous contacter concernant votre compte ou nos services</li>
                  <li>Prévenir la fraude et assurer la sécurité</li>
                  <li>Respecter nos obligations légales</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">4. Conservation des données</h2>
                <p className="text-muted-foreground">
                  Les images générées sont conservées pendant 30 jours dans votre historique. 
                  Les données de compte sont conservées jusqu'à suppression du compte, 
                  plus 3 ans pour obligations légales.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">5. Partage des données</h2>
                <p className="text-muted-foreground mb-4">
                  Nous ne vendons pas vos données personnelles. Nous pouvons partager vos données avec :
                </p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Nos sous-traitants techniques (hébergement, paiement)</li>
                  <li>Les autorités si requis par la loi</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">6. Vos droits (RGPD)</h2>
                <p className="text-muted-foreground mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Droit d'accès à vos données personnelles</li>
                  <li>Droit de rectification des données inexactes</li>
                  <li>Droit à l'effacement ("droit à l'oubli")</li>
                  <li>Droit à la portabilité de vos données</li>
                  <li>Droit d'opposition au traitement</li>
                  <li>Droit de retirer votre consentement</li>
                </ul>
                <p className="text-muted-foreground mt-4">
                  Pour exercer ces droits, contactez-nous à : <a href="mailto:privacy@floop.ai" className="text-primary hover:underline">privacy@floop.ai</a>
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">7. Sécurité</h2>
                <p className="text-muted-foreground">
                  Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données :
                  chiffrement SSL/TLS, stockage sécurisé, accès restreint, audits réguliers.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">8. Contact DPO</h2>
                <p className="text-muted-foreground">
                  Pour toute question relative à vos données personnelles, contactez notre Délégué à la Protection des Données :
                  <a href="mailto:dpo@floop.ai" className="text-primary hover:underline ml-1">dpo@floop.ai</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>

      <PremiumFooter />
    </div>
  );
};

export default Privacy;
